/**
 * Everyday Comfort: калькулятор + стрілка скролу таблиці.
 * Inline <script> у секції видаляються при fetch у .size-chart-drawer — тому логіка тут.
 */
(function () {
  var UNDERBUST_BANDS = [
    { band: 70, min: 68, max: 72 },
    { band: 75, min: 73, max: 77 },
    { band: 80, min: 78, max: 82 },
    { band: 85, min: 83, max: 87 },
    { band: 90, min: 88, max: 92 },
    { band: 95, min: 93, max: 97 },
    { band: 100, min: 98, max: 102 },
    { band: 105, min: 103, max: 107 },
    { band: 110, min: 108, max: 112 },
    { band: 115, min: 113, max: 117 },
    { band: 120, min: 118, max: 122 }
  ];
  var CUP_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  function rangeFor(band, cupLetter) {
    var idx = CUP_LETTERS.indexOf(cupLetter);
    if (idx < 0) return null;
    // Matches the old hardcoded table:
    // A: band+12..band+14, B: +14..+16, C: +16..+18, ...
    var min = band + 12 + 2 * idx;
    var max = band + 14 + 2 * idx;
    return [min, max];
  }

  function inRange(v, min, max) {
    return v >= min && v <= max;
  }
  function bandFromUnderbust(u) {
    for (var i = 0; i < UNDERBUST_BANDS.length; i++) {
      var r = UNDERBUST_BANDS[i];
      if (inRange(u, r.min, r.max)) return r.band;
    }
    return null;
  }
  function cupFromOverbust(band, b) {
    for (var i = 0; i < CUP_LETTERS.length; i++) {
      var k = CUP_LETTERS[i];
      var r = rangeFor(band, k);
      if (!r) continue;
      if (inRange(b, r[0], r[1])) return k;
    }
    return null;
  }
  function rowKeyFromLetter(cupLetter, matrix) {
    matrix = matrix || {};
    if (matrix[cupLetter]) return cupLetter;

    if (cupLetter === 'E' && matrix['DD/E']) return 'DD/E';
    if ((cupLetter === 'F' || cupLetter === 'G' || cupLetter === 'H') && matrix['DDD/F']) return 'DDD/F';

    return cupLetter;
  }

  function bindScrollArrow(root) {
    var chartWrapper = root.querySelector('.ecsg-table-wrap .size-chart-wrapper');
    var scrollArrow = root.querySelector('.ecsg-table-wrap .scroll-arrow');
    if (!chartWrapper || !scrollArrow) return;
    if (scrollArrow.dataset.ecsgBound === '1') return;
    scrollArrow.dataset.ecsgBound = '1';
    var svgChevronRight =
      '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.8452 5.43475L22.8648 11.4545L23.6603 12.25L22.8648 13.0455L16.8452 19.0651L15.2541 17.4742L19.3532 13.3751H1.00049V11.1251H19.3535L15.2541 7.02574L16.8452 5.43475Z" fill="white"/></svg>';
    var svgChevronLeft =
      '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.9999 11.7H6.41394L11.7069 6.40704L10.2929 4.99304L2.58594 12.7L10.2929 20.407L11.7069 18.993L6.41394 13.7H20.9999V11.7Z" fill="white"/></svg>';
    function updateArrow() {
      var scrollLeft = chartWrapper.scrollLeft;
      var clientWidth = chartWrapper.clientWidth;
      var scrollWidth = chartWrapper.scrollWidth;
      if (scrollLeft + clientWidth < scrollWidth - 1) {
        scrollArrow.innerHTML = svgChevronRight;
        scrollArrow.style.right = '10px';
        scrollArrow.style.left = 'auto';
      } else {
        scrollArrow.innerHTML = svgChevronLeft;
        scrollArrow.style.left = '10px';
        scrollArrow.style.right = 'auto';
      }
    }
    updateArrow();
    chartWrapper.addEventListener('scroll', updateArrow);
    window.addEventListener('resize', updateArrow);
  }

  function initEcsgRoot(root) {
    if (!root || root.getAttribute('data-ecsg-done') === '1') return;
    bindScrollArrow(root);
    var ta = root.querySelector('textarea.ecsg-payload-json');
    if (!ta) {
      root.setAttribute('data-ecsg-done', '1');
      return;
    }
    var payload;
    try {
      payload = JSON.parse(ta.value);
    } catch (e) {
      root.setAttribute('data-ecsg-done', '1');
      return;
    }
    var matrix = payload.matrix || {};
    var outputMode = payload.output || 'bra'; // 'bra' (default) | 'mapped'

    var stepsRoot = root.querySelector('.ecsg-steps[data-size-steps]');
    if (!stepsRoot || stepsRoot.getAttribute('data-ecsg-calc-inited') === '1') {
      root.setAttribute('data-ecsg-done', '1');
      return;
    }

    var st1 = stepsRoot.querySelector('[data-step="1"]');
    var st2 = stepsRoot.querySelector('[data-step="2"]');
    var st3 = stepsRoot.querySelector('[data-step="3"]');
    var underbustInput = st1 && st1.querySelector('[data-field="underbust"]');
    var bustInput = st2 && st2.querySelector('[data-field="bust"]');
    var next1 = st1 && st1.querySelector('[data-action="next"]');
    var calc2 = st2 && st2.querySelector('[data-action="calc"]');
    var outSize = st3 && st3.querySelector('[data-out="size"]');
    var restart = st3 && st3.querySelector('[data-action="restart"]');
    if (!underbustInput || !bustInput || !next1 || !calc2 || !outSize || !restart) {
      root.setAttribute('data-ecsg-done', '1');
      return;
    }

    function show(stepEl) {
      st1.hidden = true;
      st2.hidden = true;
      st3.hidden = true;
      stepEl.hidden = false;
    }

    function getBand() {
      return bandFromUnderbust(Number(underbustInput.value));
    }

    function getMappedSize() {
      var band = getBand();
      if (!band) return '';
      var cupLetter = cupFromOverbust(band, Number(bustInput.value));
      if (!cupLetter) return '';
      if (cupLetter === 'A') return '';
      var rowKey = rowKeyFromLetter(cupLetter, matrix);
      var bandStr = String(band);
      var val =
        matrix[rowKey] && matrix[rowKey][bandStr] != null ? String(matrix[rowKey][bandStr]).trim() : '';
      return val;
    }

    function calc() {
      var band = getBand();
      if (!band) {
        alert('Unterbrustumfang liegt außerhalb der Tabelle.');
        return;
      }
      var cupLetter = cupFromOverbust(band, Number(bustInput.value));
      if (!cupLetter) {
        alert('Brustumfang passt nicht zu dieser Unterbrustband-Größe.');
        return;
      }
      if (cupLetter === 'A') {
        alert('Für Cup A ist in dieser Tabelle kein Ergebnis hinterlegt.');
        return;
      }
      var rowKey = rowKeyFromLetter(cupLetter, matrix);
      var bandStr = String(band);
      var mapped =
        matrix[rowKey] && matrix[rowKey][bandStr] != null ? String(matrix[rowKey][bandStr]).trim() : '';
      if (!mapped) {
        alert('Für diese Kombination ist kein Ergebnis in der Tabelle vorhanden.');
        return;
      }

      outSize.textContent = outputMode === 'mapped' ? mapped : String(band) + cupLetter;
      show(st3);
    }

    underbustInput.addEventListener('input', function () {
      next1.disabled = !getBand();
    });
    bustInput.addEventListener('input', function () {
      calc2.disabled = !getMappedSize();
    });

    underbustInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !next1.disabled) {
        e.preventDefault();
        show(st2);
      }
    });
    bustInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !calc2.disabled) {
        e.preventDefault();
        calc();
      }
    });

    next1.addEventListener('click', function () {
      show(st2);
    });
    calc2.addEventListener('click', calc);
    restart.addEventListener('click', function () {
      underbustInput.value = '';
      bustInput.value = '';
      next1.disabled = true;
      calc2.disabled = true;
      outSize.textContent = '—';
      show(st1);
    });

    stepsRoot.setAttribute('data-ecsg-calc-inited', '1');
    root.setAttribute('data-ecsg-done', '1');
  }

  window.initEcsgRoots = function (scope) {
    scope = scope || document;
    var roots = scope.querySelectorAll ? scope.querySelectorAll('.ecsg-root') : [];
    for (var i = 0; i < roots.length; i++) {
      initEcsgRoot(roots[i]);
    }
  };

  function boot() {
    if (typeof window.initEcsgRoots === 'function') {
      window.initEcsgRoots(document);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
